(function () {
  'use strict';
  if (window.__neoFlow) { window.__neoFlow.init(document); return; }
  var roots = new WeakMap(), reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function pauseOthers(video) { document.querySelectorAll('.neo-flow video').forEach(function (v) { if (v !== video && !v.paused) v.pause(); }); }
  function closeFilm(dialog, restoreFocus) {
    if (!dialog) return;
    dialog.querySelectorAll('video').forEach(function (video) { video.pause(); });
    dialog.querySelectorAll('iframe').forEach(function (frame) { frame.remove(); });
    if (dialog.open && dialog.close) dialog.close(); else dialog.removeAttribute('open');
    if (restoreFocus !== false && dialog._neoOpener && dialog._neoOpener.isConnected) dialog._neoOpener.focus();
  }
  function initRoot(root) {
    if (roots.has(root)) return;
    var cleanups = [];
    function listen(target, name, handler, options) {
      target.addEventListener(name, handler, options);
      cleanups.push(function () { target.removeEventListener(name, handler, options); });
    }
    function observe(observer) { cleanups.push(function () { observer.disconnect(); }); return observer; }
    roots.set(root, function () {
      cleanups.forEach(function (cleanup) { cleanup(); });
      root.querySelectorAll('.neo-film-dialog').forEach(function (dialog) { closeFilm(dialog, false); });
      root.querySelectorAll('video').forEach(function (video) { video.pause(); });
      roots.delete(root);
    });
    if (root.matches('.neo-native-machine')) {
      root.querySelectorAll('.mc-s2h,.mc-s2hro,.mc-s2c,.mc-s3i,.mc-s2mfgc').forEach(function (el) { el.classList.add('neo-reveal'); });
    }
    var reveals = root.querySelectorAll('[data-neo-reveal],.neo-reveal');
    if (designMode()) {
      reveals.forEach(function (el) { el.classList.add('neo-in-view'); });
    } else if ('IntersectionObserver' in window && !reduced.matches && reveals.length) {
      var observer = observe(new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('neo-in-view'); observer.unobserve(entry.target); } }); }, { threshold:.08 }));
      reveals.forEach(function (el) { observer.observe(el); }); root.classList.add('neo-reveal-ready');
    }
    function activateStage(tab, focus) {
      var list = tab.closest('.neo-stages'); if (!list) return;
      var tabs = Array.from(list.querySelectorAll('[role="tab"]'));
      tabs.forEach(function (item, index) {
        var selected = item === tab, panel = document.getElementById(item.getAttribute('aria-controls'));
        item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1;
        if (panel && root.contains(panel)) { panel.hidden = !selected; if (selected) panel.classList.add('neo-in-view'); }
        if (selected) list.style.setProperty('--neo-stage', String(index));
      });
      if (focus) tab.focus();
    }
    root.querySelectorAll('.neo-control-story').forEach(function (story) {
      function sync() { var tabs = Array.from(story.querySelectorAll('.neo-tech-tabs [role="tab"]')); var selected = Math.max(0, tabs.findIndex(function (tab) { return tab.getAttribute('aria-selected') === 'true'; })); story.dataset.control = String(selected); story.querySelectorAll('[data-neo-label]').forEach(function (label) { label.hidden = label.getAttribute('data-neo-label') !== String(selected); }); }
      sync(); var tabs = story.querySelector('.neo-tech-tabs'); if (tabs) observe(new MutationObserver(sync)).observe(tabs, { subtree:true, attributes:true, attributeFilter:['aria-selected'] });
    });
    listen(root, 'click', function (event) {
      if (!(event.target instanceof Element)) return;
      var tab = event.target.closest('.neo-stage[role="tab"]');
      if (tab) { activateStage(tab, false); return; }
      var tech = event.target.closest('.neo-tech-tabs [role="tab"]');
      if (tech) { var story = tech.closest('.neo-control-story'); if (story) story.dataset.control = String(Array.from(tech.parentNode.querySelectorAll('[role="tab"]')).indexOf(tech)); }
      var open = event.target.closest('[data-neo-film-open]');
      if (open) {
        var dialogId = open.getAttribute('aria-controls') || open.getAttribute('data-neo-film-open'), dialog = document.getElementById(dialogId);
        if (!dialog || !root.contains(dialog)) return;
        dialog._neoOpener = open;
        var embed = dialog.querySelector('.neo-film-embed[data-src]');
        if (embed && !embed.querySelector('iframe')) {
          var source; try { source = new URL(embed.dataset.src); } catch (error) { return; }
          if (source.protocol !== 'https:' || !((['www.youtube.com','www.youtube-nocookie.com','youtube.com'].includes(source.hostname) && source.pathname.startsWith('/embed/')) || (source.hostname === 'player.vimeo.com' && source.pathname.startsWith('/video/')))) return;
          var frame = document.createElement('iframe'); frame.src = source.href; frame.title = embed.getAttribute('data-title') || 'iGulu brewing demonstration'; frame.allow = 'autoplay; encrypted-media; picture-in-picture'; frame.allowFullscreen = true; embed.appendChild(frame);
        }
        if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
        var filmVideo = dialog.querySelector('video'); if (filmVideo) { pauseOthers(filmVideo); filmVideo.play().catch(function () {}); }
        return;
      }
      var close = event.target.closest('[data-neo-film-close]');
      if (close) { closeFilm(close.closest('.neo-film-dialog')); return; }
      var play = event.target.closest('[data-neo-video-play]');
      if (play) {
        var reel = play.closest('.neo-reel'), video = reel && reel.querySelector('video');
        if (video) { pauseOthers(video); video.controls = true; video.play().catch(function () {}); }
      }
    });
    listen(root, 'keydown', function (event) {
      var tab = event.target.closest && event.target.closest('.neo-stage[role="tab"]'); if (!tab) return;
      var tabs = Array.from(tab.closest('.neo-stages').querySelectorAll('[role="tab"]')), index = tabs.indexOf(tab);
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
      else if (event.key === 'Home') index = 0; else if (event.key === 'End') index = tabs.length - 1; else return;
      event.preventDefault(); activateStage(tabs[index], true);
    });
    // For an existing clip without a separate poster, display its own first
    // frame. Seek only when near the viewport; do not autoplay the clip.
    root.querySelectorAll('.neo-reel video:not([poster]),video[data-neo-poster-video]').forEach(function (video) {
      function prime() {
        if (video.dataset.neoPrimed) return;
        video.dataset.neoPrimed = 'true';
        function seek() { if (video.paused && video.currentTime === 0) video.currentTime = Math.min(.1, video.duration || .1); }
        if (video.readyState >= 1) seek(); else listen(video, 'loadedmetadata', seek, { once:true });
      }
      if ('IntersectionObserver' in window) {
        var posterObserver = observe(new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) { prime(); posterObserver.disconnect(); } }, { rootMargin:'200px' }));
        posterObserver.observe(video);
      } else prime();
    });
    root.querySelectorAll('.neo-film-dialog').forEach(function (dialog) {
      listen(dialog, 'click', function (event) { if (event.target === dialog) { var r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeFilm(dialog); } });
      listen(dialog, 'cancel', function (event) { event.preventDefault(); closeFilm(dialog); });
      listen(dialog, 'close', function () { dialog.querySelectorAll('video').forEach(function (v) { v.pause(); }); dialog.querySelectorAll('iframe').forEach(function (f) { f.remove(); }); });
    });
    listen(root, 'play', function (event) { var video = event.target; if (!(video instanceof HTMLVideoElement)) return; pauseOthers(video); var reel = video.closest('.neo-reel'); if (reel) reel.classList.add('is-playing'); }, true);
    ['pause','ended'].forEach(function (name) { listen(root, name, function (event) { var reel = event.target.closest && event.target.closest('.neo-reel'); if (reel) reel.classList.remove('is-playing'); }, true); });
    listen(root, 'shopify:block:select', function (event) {
      if (!(event.target instanceof Element)) return;
      // The editor can select a visible tab or its currently hidden panel.
      var selected = event.target.closest('.neo-stage[role="tab"],.neo-stage-panel');
      if (!selected && event.detail && event.detail.blockId) {
        selected = Array.from(root.querySelectorAll('[data-neo-block]')).find(function (element) { return element.getAttribute('data-neo-block') === event.detail.blockId && element.matches('.neo-stage[role="tab"],.neo-stage-panel'); });
      }
      if (!selected || !root.contains(selected)) return;
      var tab = selected.matches('.neo-stage[role="tab"]') ? selected : document.getElementById(selected.getAttribute('aria-labelledby'));
      if (tab && root.contains(tab)) activateStage(tab, false);
    });
  }
  function init(scope) { if (scope.matches && scope.matches('.neo-flow,.neo-native-machine')) initRoot(scope); if (scope.querySelectorAll) scope.querySelectorAll('.neo-flow,.neo-native-machine').forEach(initRoot); }
  function destroy(scope) {
    if (!scope) return;
    if (roots.has(scope)) roots.get(scope)();
    if (scope.querySelectorAll) scope.querySelectorAll('.neo-flow,.neo-native-machine').forEach(function (root) { if (roots.has(root)) roots.get(root)(); });
  }
  var framePending = false;
  function parallax() {
    framePending = false; if (reduced.matches || designMode()) return;
    document.querySelectorAll('.neo-flow .neo-orbit-product,.neo-native-machine .mc-s2hero-pc').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight) el.style.setProperty('--neo-parallax', Math.max(-10, Math.min(10, (innerHeight / 2 - r.top - r.height / 2) * .025)).toFixed(1) + 'px'); });
  }
  window.addEventListener('scroll', function () { if (!framePending) { framePending = true; requestAnimationFrame(parallax); } }, { passive:true });
  window.__neoFlow = { init:init, destroy:destroy };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once:true }); else init(document);
}());
